import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';

const selectUser = () => state => state.app.user;
const selectLeadsPageDomain = () => state => state.leads;

const selectFetching = () => createSelector(
  selectLeadsPageDomain(),
  substate => substate.fetching
)

const filterFormSelector = formValueSelector('lead_filter');
const selectFilterForm = () => state => {
  const dateRange = filterFormSelector(state, 'date_range');
  const sourceChannel = filterFormSelector(state, 'source_channel');
  const search = filterFormSelector(state, 'search_term');
  return {
    dateRange,
    sourceChannel,
    search
  };
};

const selectAllLeads = () => createSelector(
  selectLeadsPageDomain(),
  substate => substate.allLeads
);

const selectPagingObject = () => createSelector(
  selectLeadsPageDomain(),
  substate => substate.paging
);

export {
    selectUser,
    selectFilterForm,
    selectFetching,
    selectAllLeads,
    selectPagingObject,
  };


// WEBPACK FOOTER //
// ./src/containers/LeadsPage/selectors.js